enum Plan {
  Free = 'free',
  ProDay = 'pro.day',
  ProMonthly = 'pro.monthly',
  ProYearly = 'pro.yearly',
  ProLife = 'pro.life',
  ProLifeAppsumo = 'pro.life.appsumo',
  ProEvangelist = 'pro.evangelist'
}

export const getPaidPlanFromPeriod = (
  period: 'day' | 'month' | 'year'
): Plan => {
  switch (period) {
    case 'day':
      return Plan.ProDay;
    case 'month':
      return Plan.ProMonthly;
    case 'year':
      return Plan.ProYearly;
    default:
      throw new Error(`Cannot find plan for period: ${period}`);
  }
};

export default Plan;



// WEBPACK FOOTER //
// ./src/buy/Plan.ts